import Vue from 'vue'
import dayJs from 'dayjs'

Vue.filter('showFullPriceFormat', (number = 0) => {
  const str = parseFloat(number).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return str
})

Vue.filter('localDate', (date) => {
  const formatedDate = new Date(date)
  return dayJs(formatedDate).format('DD-MM-YYYY HH:mm')
})
